import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';
import { useInstanceId } from '../../../../hooks';

type MoveToCategoryProps = {
  deeplink: string;
};

const parseScreensDeeplink = (deeplink: string) => {
  const url = new URL(deeplink);
  const screenName = url.searchParams.get('screen_name');
  const nextToken = url.searchParams.get('next_token');

  return { screen_name: screenName, next_token: nextToken };
};

export const useMoveToCategory = () => {
  const navigation = useRootStackNavigation();
  const instanceId = useInstanceId();

  return useCallback(
    ({ deeplink }: MoveToCategoryProps) => {
      const params = parseScreensDeeplink(deeplink);

      navigation.push('Screens', {
        instanceId,
        ...params,
      });
    },
    [navigation, instanceId],
  );
};
